import React from 'react'
import BaseForm from './base-form.component'
import StyledStepFrom from './styled-step-from.component'
import TermsAndConditionsForm from './terms-and-conditions-form.component'

export default class StepFiveTermsAndConditionsForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<TermsAndConditionsForm
					initialValues={this.props.initialValues}
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
				/>
			</StyledStepFrom>
		)
	}
}
